/* eslint-disable use-isnan */
import { Button } from "@mui/material";
import React, { memo, useState, useEffect } from "react";

let myLatLng = { lat: 37.480294605, lng: 126.877148315 };
let myRange = 10;

const GeoMap = () => {
  const [selectedElementId, setSelectedElementId] = useState("text1");
  const [inputValues, setInputValues] = useState({});
  const [inputValues2, setInputValues2] = useState({});
  const [circles, setCircles] = useState([]);
  const [map, setMap] = useState(null);
  const [markers, setMarkers] = useState({});

  useEffect(() => {
    // URL에서 JSON 파라미터 추출
    const urlParams = new URLSearchParams(window.location.search);
    const jsonParam = urlParams.get("json");

    // JSON 파라미터를 객체로 변환하여 inputValues에 설정
    if (jsonParam) {
      const parsedData = JSON.parse(decodeURIComponent(jsonParam));
      const newInputValues = {};
      const newInputValues2 = {};
      parsedData.forEach((data, index) => {
        const textKey = `text${index + 1}`;
        const rangeKey = `range${index + 1}`;
        newInputValues[textKey] = `${data.lat}, ${data.lon}`;
        newInputValues2[rangeKey] = `${data.range}`;
      });
      setInputValues(newInputValues);
      setInputValues2(newInputValues2);
    } else {
      setInputValues({});
      setInputValues2({
        range1: "10",
        range2: "10",
        range3: "10",
      });
    }
  }, []);

  const initMap = (selectedElementId) => {
    const inputElement = document.getElementById(selectedElementId).value;
    const valuesArray = inputElement?.split(",").map((value) => value.trim());
    if (
      valuesArray.length >= 2 &&
      !isNaN(parseFloat(valuesArray[0])) &&
      !isNaN(parseFloat(valuesArray[1]))
    ) {
      myLatLng = {
        lat: parseFloat(valuesArray[0]),
        lng: parseFloat(valuesArray[1]),
      };
    }
    const lastChar = selectedElementId.charAt(selectedElementId.length - 1);
    if (!isNaN(parseFloat(inputValues2[`range${lastChar}`]))) {
      myRange = parseFloat(inputValues2[`range${lastChar}`]);
    }

    const map = new window.google.maps.Map(document.getElementById("map"), {
      zoom: 17,
      center: myLatLng,
    });
    setMap(map);
    let infoWindow;
    if (inputValues[selectedElementId] === "") {
      infoWindow = new window.google.maps.InfoWindow({
        content: "CLICK TO SET GEO LOCATION",
        position: myLatLng,
      });
    } else {
      infoWindow = new window.google.maps.InfoWindow({
        content: "GEO LOCATION",
        position: myLatLng,
      });

      Object.keys(inputValues).forEach((key) => {
        const latLngString = inputValues[key];
        const lastChar = key.charAt(key.length - 1);
        const range = `range${lastChar}`;
        const [lat, lng] = latLngString.split(",").map(parseFloat);

        if (markers[lastChar]) {
          markers[lastChar].setMap(null);
        }

        // 마커 생성하여 원의 중심에 추가
        markers[lastChar] = new window.google.maps.Marker({
          position: { lat, lng },
          label: lastChar.toString(), // 숫자 표시
          map: map,
        });

        // 새로운 원 그리기
        const newCircle = new window.google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          map: map,
          center: { lat, lng },
          radius: parseInt(inputValues2[range] || 10), // 원의 반지름 설정
          id: `Circle${key}`,
        });

        // 이전에 그렸던 원과 새로운 원을 포함하는 배열로 업데이트
        setCircles((prevCircles) => [...prevCircles, newCircle]);
      });
    }

    infoWindow.open(map);
    map.addListener("click", (mapsMouseEvent) => {
      const inputElement = document.getElementById(selectedElementId);
      if (inputElement) {
        setInputValues((prevValues) => ({
          ...prevValues,
          [selectedElementId]: `${mapsMouseEvent.latLng
            .lat()
            .toFixed(9)}, ${mapsMouseEvent.latLng.lng().toFixed(9)}`,
        }));
      }
    });

    document.getElementById("radio1").value = "3";
  };

  const handleRadioChange = (option) => {
    setSelectedElementId(option);
  };

  useEffect(() => {
    if (
      typeof window.google !== "undefined" &&
      typeof window.google.maps !== "undefined"
    ) {
      // 입력된 값들을 순회하면서 원 생성
      Object.keys(inputValues).forEach((key) => {
        const latLngString = inputValues[key];
        const lastChar = key.charAt(key.length - 1);
        const range = `range${lastChar}`;
        const [lat, lng] = latLngString.split(",").map(parseFloat);

        if (markers[lastChar]) {
          markers[lastChar].setMap(null);
        }

        // 마커 생성하여 원의 중심에 추가
        markers[lastChar] = new window.google.maps.Marker({
          position: { lat, lng },
          label: lastChar.toString(), // 숫자 표시
          map: map,
        });

        // 새로운 원 그리기
        const newCircle = new window.google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          map: map,
          center: { lat, lng },
          radius: parseInt(inputValues2[range] || 10), // 원의 반지름 설정
        });

        // 이전에 그렸던 원과 새로운 원을 포함하는 배열로 업데이트
        setCircles((prevCircles) => [...prevCircles, newCircle]);
      });
    }
  }, [inputValues, inputValues2, map]);

  useEffect(() => {
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_API_KEY}`;
    script.async = true;
    script.defer = true;
    document.head.appendChild(script);

    script.onload = () => {
      initMap(selectedElementId);
    };

    return () => {
      document.head.removeChild(script);
      delete window.initMap;
    };
  }, [selectedElementId, inputValues2]);

  const geoData = [
    { id: "text1", label: "GEO 1", placeholder: "LAT, LON", type: "text" },
    { id: "text2", label: "GEO 2", placeholder: "LAT, LON", type: "text" },
    { id: "text3", label: "GEO 3", placeholder: "LAT, LON", type: "text" },
  ];

  const rangeData = [
    { id: "range1", placeholder: "RANGE(m)", type: "number" },
    { id: "range2", placeholder: "RANGE(m)", type: "number" },
    { id: "range3", placeholder: "RANGE(m)", type: "number" },
  ];

  useEffect(() => {
    if (map) {
      const clickListener = map.addListener("click", (mapsMouseEvent) => {
        const latLng = mapsMouseEvent.latLng;

        // 이전에 그렸던 모든 원 삭제
        circles.forEach((circle) => {
          circle.setMap(null); // 지도에서 제거
        });

        // 새로운 원 그리기
        const newCircle = new window.google.maps.Circle({
          strokeColor: "#FF0000",
          strokeOpacity: 0.8,
          strokeWeight: 2,
          fillColor: "#FF0000",
          fillOpacity: 0.35,
          map: map,
          center: latLng,
          radius: myRange, // 원의 반지름 설정
        });

        // 이전에 그렸던 원과 새로운 원을 포함하는 배열로 업데이트
        setCircles((prevCircles) => [...prevCircles, newCircle]);
      });

      return () => {
        window.google.maps.event.removeListener(clickListener);
      };
    }
  }, [map, inputValues2, circles]);

  const handleInputChange = (elementId, value, valuesSetter) => {
    valuesSetter((prevValues) => ({
      ...prevValues,
      [elementId]: value,
    }));
  };

  const handleSaveClick = () => {
    const combinedValues = {
      ...inputValues,
      ...inputValues2,
    };
    window.opener.postMessage(combinedValues, window.location.origin);
  };

  return (
    <>
      <div id="map" style={{ width: "100%", height: "500px" }}></div>
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          justifyContent: "center",
          alignContent: "center",
          margin: "15px 0",
        }}
      >
        {[...geoData, ...rangeData].map((data, index) => (
          <div
            key={index}
            style={{ margin: "5px 0 2px", textAlign: "left", width: "30%" }}
          >
            {data.type === "text" && (
              <>
                <input
                  type="radio"
                  name="geo"
                  id={`radio${index + 1}`}
                  onChange={() => handleRadioChange(data.id)}
                  style={{ marginRight: "10px" }}
                  checked={selectedElementId === data.id}
                />
                <label htmlFor={`radio${index + 1}`} style={{ width: "100px" }}>
                  {data.label}
                </label>
                <input
                  type={data.type}
                  id={data.id}
                  placeholder={data.placeholder}
                  style={{
                    marginLeft: "10px",
                    width: "250px",
                    textAlign: "center",
                    outline: "none",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    padding: "4px 2px",
                  }}
                  value={inputValues[data.id] || ""}
                  onChange={(e) =>
                    handleInputChange(data.id, e.target.value, setInputValues)
                  }
                />
              </>
            )}

            {data.type === "number" && (
              <>
                <input
                  type={data.type}
                  id={data.id}
                  placeholder={data.placeholder}
                  style={{
                    marginLeft: "85px",
                    width: "100px",
                    textAlign: "center",
                    outline: "none",
                    border: "1px solid #ddd",
                    borderRadius: "4px",
                    padding: "4px 2px",
                  }}
                  value={inputValues2[data.id] || 10}
                  onChange={(e) =>
                    handleInputChange(data.id, e.target.value, setInputValues2)
                  }
                />
              </>
            )}
          </div>
        ))}
      </div>
      <div
        style={{
          margin: "0 auto",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <div>
          <Button
            variant="contained"
            style={{ marginRight: "5px" }}
            onClick={handleSaveClick}
          >
            Save
          </Button>
        </div>
        <div>
          <Button variant="outlined" onClick={() => window.close()}>
            Cancel
          </Button>
        </div>
      </div>
    </>
  );
};

export default memo(GeoMap);
